// extracted by mini-css-extract-plugin
export var Color = "Color-module--Color--4vslk";